/* global saveAs, Blob, BlobBuilder, console */
/* exported ics */
// import saveAs from "./fileSave";
import * as moment from "moment-timezone";

export const ics = function (uidDomain, prodId) {
  "use strict";

  if (navigator.userAgent.indexOf("MSIE") > -1 && navigator.userAgent.indexOf("MSIE 10") == -1) {
    console.log("Unsupported Browser");
    return;
  }

  if (typeof uidDomain === "undefined") {
    uidDomain = "default";
  }
  if (typeof prodId === "undefined") {
    prodId = "Calendar";
  }

  var SEPARATOR = navigator.appVersion.indexOf("Win") !== -1 ? "\r\n" : "\n";
  var calendarEvents = [];
  var calendarStart = ["BEGIN:VCALENDAR", "PRODID:" + prodId, "VERSION:2.0"].join(SEPARATOR);
  var calendarEnd = SEPARATOR + "END:VCALENDAR";
  var BYDAY_VALUES = ["SU", "MO", "TU", "WE", "TH", "FR", "SA"];

  return {
    /**
     * Returns events array
     * @return {array} Events
     */
    events: function () {
      return calendarEvents;
    },

    /**
     * Returns calendar
     * @return {string} Calendar in iCalendar format
     */
    calendar: function () {
      return calendarStart + SEPARATOR + calendarEvents.join(SEPARATOR) + calendarEnd;
    },

    /**
     * Add event to the calendar
     * @param  {string} subject     Subject/Title of event
     * @param  {string} description Description of event
     * @param  {string} location    Location of event
     * @param  {string} begin       Beginning date of event
     * @param  {string} stop        Ending date of event
     */
    addEvent: function (subject, description, location, begin, stop, timezone, attendees, emailId) {
      // I'm not in the mood to make these optional... So they are all required
      if (
        typeof subject === "undefined" ||
        typeof description === "undefined" ||
        typeof location === "undefined" ||
        typeof begin === "undefined" ||
        typeof stop === "undefined"
      ) {
        return false;
      }

      //TODO add time and time zone? use moment to format?
      var start_date = new Date(begin);
      var end_date = new Date(stop);
      var now_date = new Date();

      var start_year = ("0000" + start_date.getFullYear().toString()).slice(-4);
      var start_month = ("00" + (start_date.getMonth() + 1).toString()).slice(-2);
      var start_day = ("00" + start_date.getDate().toString()).slice(-2);
      var start_hours = ("00" + start_date.getHours().toString()).slice(-2);
      var start_minutes = ("00" + start_date.getMinutes().toString()).slice(-2);
      var start_seconds = ("00" + start_date.getSeconds().toString()).slice(-2);

      var end_year = ("0000" + end_date.getFullYear().toString()).slice(-4);
      var end_month = ("00" + (end_date.getMonth() + 1).toString()).slice(-2);
      var end_day = ("00" + end_date.getDate().toString()).slice(-2);
      var end_hours = ("00" + end_date.getHours().toString()).slice(-2);
      var end_minutes = ("00" + end_date.getMinutes().toString()).slice(-2);
      var end_seconds = ("00" + end_date.getSeconds().toString()).slice(-2);

      var now_year = ("0000" + now_date.getFullYear().toString()).slice(-4);
      var now_month = ("00" + (now_date.getMonth() + 1).toString()).slice(-2);
      var now_day = ("00" + now_date.getDate().toString()).slice(-2);
      var now_hours = ("00" + now_date.getHours().toString()).slice(-2);
      var now_minutes = ("00" + now_date.getMinutes().toString()).slice(-2);
      var now_seconds = ("00" + now_date.getSeconds().toString()).slice(-2);

      // Since some calendars don't add 0 second events, we need to remove time if there is none...
      var start_time = "";
      var end_time = "";
      if (start_hours + start_minutes + start_seconds + end_hours + end_minutes + end_seconds != 0) {
        start_time = "T" + start_hours + start_minutes + start_seconds;
        end_time = "T" + end_hours + end_minutes + end_seconds;
      }
      var now_time = "T" + now_hours + now_minutes + now_seconds;

      var start = start_year + start_month + start_day + start_time;
      var end = end_year + end_month + end_day + end_time;
      var now = now_year + now_month + now_day + now_time;

      var stamp = new Date().toISOString();
      var momentStart = moment.tz(start, timezone);
      var momentEnd = moment.tz(end, timezone);
      var momentNow = moment.tz(now, timezone);
      var dtstartUtc = momentStart.utc();
      var dtEndUtc = momentEnd.utc();
      var dtNowUtc = momentNow.utc();
      var dtstartUtcStr = dtstartUtc.format("YYYYMMDDTHHmmss") + "Z";
      var dtEndUtcStr = dtEndUtc.format("YYYYMMDDTHHmmss") + "Z";
      var dtNowUtcStr = dtNowUtc.format("YYYYMMDDTHHmmss") + "Z";
      var calendarEvent = [
        "BEGIN:VCALENDAR",
        "VERSION:2.0",
        "PRODID:" + prodId,
        "CALSCALE:GREGORIAN",
        "METHOD:PUBLISH",
        "BEGIN:VTIMEZONE",
        "TZID:" + timezone,
        "TZURL:http://tzurl.org/zoneinfo/" + timezone,
        "X-LIC-LOCATION:" + timezone,
        "END:VTIMEZONE",
        "BEGIN:VEVENT",
        "SUMMARY:" + subject,
        "UID:" + randStr(15),
        "SEQUENCE:310685407",
        "STATUS:CONFIRMED",
        "ORGANIZER;CN=Unknown Resource:mailto:noreply@xfinity.com",
        "ATTENDEE;CN=" + attendees + ":mailto:" + emailId,
        "TRANSP:TRANSPARENT",
        //"DTSTART;TZID=" + timezone + ":" + start,
        //"DTEND;TZID=" + timezone + ":" + end,
        "DTSTART:" + dtstartUtcStr,
        "DTEND:" + dtEndUtcStr,
        //"DTSTAMP:" + now,
        "DTSTAMP:" + dtNowUtcStr,
        "CATEGORIES:xfinity store appointment",
        "LOCATION:" + location,
        "DESCRIPTION:" + description,
        "END:VEVENT",
        "END:VCALENDAR",
      ];

      calendarEvent = calendarEvent.join(SEPARATOR);

      calendarEvents.push(calendarEvent);
    },

    /**
     * Download calendar using the saveAs function from filesave.js
     * @param  {string} filename Filename
     * @param  {string} ext      Extention
     */
    download: function (filename, ext) {
      if (calendarEvents.length < 1) {
        return false;
      }

      ext = typeof ext !== "undefined" ? ext : ".ics";
      filename = typeof filename !== "undefined" ? filename : "calendar";
      //var calendar = calendarStart + SEPARATOR + calendarEvents.join(SEPARATOR) + calendarEnd;
      var calendar = calendarEvents.join(SEPARATOR);
      var blob;
      if (navigator.userAgent.indexOf("MSIE 10") === -1) {
        // chrome or firefox
        blob = new Blob([calendar], { type: "text/calendar" });
      } else {
        // ie
        var bb = new BlobBuilder();
        bb.append(calendar);
        //blob = bb.getBlob("text/x-vCalendar;charset=" + document.characterSet);
        blob = bb.getBlob("text/calendar;charset=" + document.characterSet + ";");
        console.warn("inside file download method else block icsgen");
      }
      console.warn("file info: ", blob, filename + ext);
      saveAs(blob, filename + ext);
      return calendar;
    },

    /**
     * Build and return the ical contents
     */
    build: function () {
      if (calendarEvents.length < 1) {
        return false;
      }

      var calendar = calendarStart + SEPARATOR + calendarEvents.join(SEPARATOR) + calendarEnd;

      return calendar;
    },
  };
};
/*
 * FileSaver.js
 * A saveAs() FileSaver implementation.
 *
 * By Eli Grey, http://eligrey.com
 *
 * License : https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md (MIT)
 * source  : http://purl.eligrey.com/github/FileSaver.js
 */

// The one and only way of getting global scope in all environments
// https://stackoverflow.com/q/3277182/1008999
var _global =
  typeof window === "object" && window.window === window
    ? window
    : typeof self === "object" && self.self === self
    ? self
    : typeof global === "object" && global.global === global
    ? global
    : this;

function randStr(len, chars = "appointment12345") {
  let s = "";
  while (len--) s += chars[Math.floor(Math.random() * chars.length)];
  return s;
}

function bom(blob, opts) {
  if (typeof opts === "undefined") opts = { autoBom: false };
  else if (typeof opts !== "object") {
    opts = { autoBom: !opts };
  }

  // prepend BOM for UTF-8 XML and text/* types (including HTML)
  // note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
  if (opts.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
    return new Blob([String.fromCharCode(0xfeff), blob], { type: blob.type });
  }
  return blob;
}

function download(url, name, opts) {
  var xhr = new XMLHttpRequest();
  xhr.open("GET", url);
  xhr.responseType = "blob";
  xhr.onload = function () {
    saveAs(xhr.response, name, opts);
  };
  xhr.onerror = function () {
    console.error("could not download file");
  };
  xhr.send();
}

function corsEnabled(url) {
  var xhr = new XMLHttpRequest();
  // use sync to avoid popup blocker
  xhr.open("HEAD", url, false);
  try {
    xhr.send();
  } catch (e) {}
  return xhr.status >= 200 && xhr.status <= 299;
}

// `a.click()` doesn't work for all browsers (#465)
function click(node) {
  try {
    node.dispatchEvent(new MouseEvent("click"));
  } catch (e) {
    var evt = document.createEvent("MouseEvents");
    evt.initMouseEvent("click", true, true, window, 0, 0, 0, 80, 20, false, false, false, false, 0, null);
    node.dispatchEvent(evt);
  }
}

// Detect WebView inside a native macOS app by ruling out all browsers
// We just need to check for 'Safari' because all other browsers (besides Firefox) include that too
// https://www.whatismybrowser.com/guides/the-latest-user-agent/macos
var isMacOSWebView =
  _global.navigator &&
  /Macintosh/.test(navigator.userAgent) &&
  /AppleWebKit/.test(navigator.userAgent) &&
  !/Safari/.test(navigator.userAgent);

var saveAs =
  _global.saveAs ||
  // probably in some web worker
  (typeof window !== "object" || window !== _global
    ? function saveAs() {
        /* noop */
      }
    : // Use download attribute first if possible (#193 Lumia mobile) unless this is a macOS WebView
    "download" in HTMLAnchorElement.prototype && !isMacOSWebView
    ? function saveAs(blob, name, opts) {
        var URL = _global.URL || _global.webkitURL;
        var a = document.createElement("a");
        var fileName = name || blob.name || "AppointmentEvent.ics";
        a.setAttribute("download", fileName);
        a.setAttribute("rel", "noopener");
        console.warn("inside save as first check", fileName);
        // TODO: detect chrome extensions & packaged apps
        // a.target = '_blank'
        if (typeof blob === "string") {
          // Support regular links
          a.href = blob;
          if (a.origin !== location.origin) {
            corsEnabled(a.href) ? download(blob, name, opts) : click(a, (a.target = "_blank"));
          } else {
            click(a);
          }
        } else {
          // Support blobs
          var isChromeIOS = /CriOS\/[\d]+/.test(navigator.userAgent);
          console.warn("inside save as first check else", fileName, "isChromeIos" + isChromeIOS);
          if (isChromeIOS) {
            var reader = new FileReader();
            blob.name = fileName;
            reader.onloadend = function (e) {
              window.location.href = reader.result;
            };
            // reader.fileName = fileName;
            reader.readAsDataURL(blob);

            /*let file = new File([blob], fileName, { type: "text/calendar" });
              let exportUrl = URL.createObjectURL(file);
              window.location.assign(exportUrl);
              URL.revokeObjectURL(exportUrl);*/
          } else {
            a.setAttribute("href", URL.createObjectURL(blob));
            a.setAttribute("target", "_blank");
            setTimeout(function () {
              URL.revokeObjectURL(a.href);
            }, 1000);
            setTimeout(function () {
              click(a);
            }, 100);
          }
        }
      }
    : // Use msSaveOrOpenBlob as a second approach
    "msSaveOrOpenBlob" in navigator
    ? function saveAs(blob, name, opts) {
        name = name || blob.name || "download";

        if (typeof blob === "string") {
          if (corsEnabled(blob)) {
            download(blob, name, opts);
          } else {
            var a = document.createElement("a");
            a.href = blob;
            a.target = "_blank";
            setTimeout(function () {
              click(a);
            });
          }
        } else {
          navigator.msSaveOrOpenBlob(bom(blob, opts), name);
        }
        console.warn("inside save as second check", name);
      }
    : // Fallback to using FileReader and a popup
      function saveAs(blob, name, opts, popup) {
        // Open a popup immediately do go around popup blocker
        // Mostly only available on user interaction and the fileReader is async so...
        popup = popup || open("", "_blank");
        if (popup) {
          popup.document.title = popup.document.body.innerText = "downloading...";
        }

        if (typeof blob === "string") return download(blob, name, opts);

        var force = blob.type === "application/octet-stream";
        var isSafari = /constructor/i.test(_global.HTMLElement) || _global.safari;
        var isChromeIOS = /CriOS\/[\d]+/.test(navigator.userAgent);
        console.warn(
          "inside save as third check",
          fileName,
          force,
          "isSafari:" + isSafari,
          "isMAcOswebview:" + isMacOSWebView,
          "isSafari:" + isSafari
        );
        if ((isChromeIOS || (force && isSafari) || isMacOSWebView) && typeof FileReader !== "undefined") {
          // Safari doesn't allow downloading of blob URLs
          var reader = new FileReader();
          reader.onloadend = function () {
            var url = reader.result;
            url = isChromeIOS ? url : url.replace(/^data:[^;]*;/, "data:attachment/file;");
            if (popup) popup.location.href = url;
            else location = url;
            popup = null; // reverse-tabnabbing #460
          };
          reader.readAsDataURL(blob);
        } else {
          var URL = _global.URL || _global.webkitURL;
          var url = URL.createObjectURL(blob);
          if (popup) popup.location = url;
          else location.href = url;
          popup = null; // reverse-tabnabbing #460
          setTimeout(function () {
            URL.revokeObjectURL(url);
          }, 4e4); // 40s
        }
      });

_global.saveAs = saveAs.saveAs = saveAs;

if (typeof module !== "undefined") {
  module.exports = saveAs;
}
